module.exports = __webpack_public_path__ + "img/flecha_azul_i.74d7b801.svg";